module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ACV"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "JANUARY 2: At Work Behind the Scenes"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pAqZ"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#AB_ch03",
      "id": "AB_cha03"
    }
  }, [_vm._v("JANUARY 2"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "chapter2a"
  }, [_vm._v("At Work Behind the Scenes")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "pAq9"
    }
  }, [_c('em', [_vm._v("A man’s heart plans his way, but the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" directs his steps.")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pAgGx"
    }
  }, [_vm._v("—Proverbs 16:9")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pAmf"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("H")])]), _vm._v("ave you ever had to make a decision and then watched the situation turn out better than you’d hoped? Consider a couple of examples:")]), _vm._v(" "), _c('ul', {
    staticClass: "ula",
    attrs: {
      "id": "AbNZ"
    }
  }, [_c('li', {
    attrs: {
      "id": "pAmq"
    }
  }, [_vm._v("The worship leader needed a substitute singer—in half an hour. He wasn’t sure why Haley came to mind, but he was confident she was the one he should call. Haley had just been turned down for the lead in the school musical, and now she was the worship leader’s first choice!")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "pA3e"
    }
  }, [_vm._v("The temp agency sent many possible hires to the human resources department. One of them, Brenda, had been interviewing at various businesses and sensed God telling her to accept the first offer that came. Before he interviewed people for the position, the decision maker in HR had prayed for guidance, and he was the first to offer Brenda a job. Now another believer brings God’s light and grace to that company.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAlf"
    }
  }, [_vm._v("When we realize that the Lord has worked behind the scenes, let’s be quick to thank Him. Hindsight offers many reasons to grow in gratitude!")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pAJU"
    }
  }, [_c('em', [_vm._v("I am grateful, Lord, for the hope-and peace-giving truth that You are at work in my life!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b93d6bac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter03.vue
// module id = 75
// module chunks = 0